import React, { useState } from "react";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { useLang } from "@/context/Lang";
import { IMAGES } from "@/data";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Gallery() {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");
  const filters = ["all", "pintura", "reforma", "drywall"];
  const items = IMAGES.gallery.filter((g) => filter === "all" || g.cat === filter);

  return (
    <section id="gallery" className="bg-white py-24 md:py-32" data-testid="gallery">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10">
          <Overline>{t.gallery.overline}</Overline>
          <h2 className="mt-4 font-display font-extrabold text-navy text-4xl md:text-6xl leading-[0.95] tracking-tighter">
            {t.gallery.title}
          </h2>
          <p className="mt-4 text-navy/55">{t.gallery.sub} →</p>
        </Reveal>

        <div className="flex flex-wrap gap-3 mb-10">
          {filters.map((f) => (
            <button
              key={f}
              data-testid={`gallery-filter-${f}`}
              onClick={() => setFilter(f)}
              className={`px-5 py-2 rounded-full text-sm font-bold transition-colors border ${
                filter === f
                  ? "bg-navy text-white border-navy"
                  : "bg-transparent text-navy/60 border-navy/15 hover:border-navy/40"
              }`}
            >
              {t.gallery.filters[f]}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {items.map((g, i) => (
            <Reveal key={g.id} delay={i * 0.08} className="relative border border-navy/10">
              <div className="relative aspect-[4/3]" data-testid={`compare-${g.id}`}>
                <ReactCompareSlider
                  className="h-full"
                  itemOne={<ReactCompareSliderImage src={g.before} alt={`Before — ${g.cat} home renovation project by Seven Home Services`} />}
                  itemTwo={<ReactCompareSliderImage src={g.after} alt={`After — completed ${g.cat} home renovation by Seven Home Services`} />}
                />
                <span className="absolute top-4 left-4 z-10 bg-navy/80 text-white text-xs font-bold tracking-widest px-3 py-1.5 pointer-events-none">
                  {t.gallery.before}
                </span>
                <span className="absolute top-4 right-4 z-10 bg-orange text-white text-xs font-bold tracking-widest px-3 py-1.5 pointer-events-none">
                  {t.gallery.after}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <span className="text-navy/70 font-semibold text-lg">{t.gallery.ctaText}</span>
          <button
            data-testid="gallery-cta"
            onClick={() => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center justify-center gap-2 bg-orange hover:bg-[#1550C0] text-white font-bold px-7 py-3.5 rounded-full transition-colors"
          >
            {t.gallery.ctaBtn}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
